"use client";

import { c as _c } from "react/compiler-runtime";
import { Activity, use } from "react";
import { fyllUtPlanSkjemaFullfortEvent, fyllUtPlanSkjemaStegFullfortEvent } from "@/common/analytics/events-and-properties/skjema-events";
import { logAnalyticsEvent } from "@/common/analytics/logAnalyticsEvent";
import type { ConvertedLagretUtkastResponse } from "@/schema/utkastResponseSchema";
import FyllUtPlanSteg from "./FyllUtPlanSteg/FyllUtPlanSteg";
import useOppfolgingsplanForm from "./FyllUtPlanSteg/form/hooks/useOppfolgingsplanForm";
import OppsummeringSteg from "./OppsummeringSteg/OppsummeringSteg";
export enum VeiviserSteg {
  FYLL_UT_PLAN = "FYLL_UT_PLAN",
  OPPSUMMERING = "OPPSUMMERING",
}
interface Props {
  lagretUtkastPromise: Promise<ConvertedLagretUtkastResponse>;
  erITiltaksgruppePromise: Promise<boolean>;
}
export default function LagPlanVeiviser(t0) {
  const $ = _c(38);
  const {
    lagretUtkastPromise,
    erITiltaksgruppePromise
  } = t0;
  const {
    userHasEditAccess,
    utkast
  } = use(lagretUtkastPromise);
  const erITiltaksgruppe = use(erITiltaksgruppePromise);
  const initialLagretUtkast = utkast?.content || null;
  const initialSistLagretTidspunkt = utkast?.sistLagretTidspunkt || null;
  let t1;
  if ($[0] !== erITiltaksgruppe || $[1] !== initialLagretUtkast || $[2] !== initialSistLagretTidspunkt) {
    t1 = {
      initialLagretUtkast,
      initialSistLagretTidspunkt,
      erITiltaksgruppe
    };
    $[0] = erITiltaksgruppe;
    $[1] = initialLagretUtkast;
    $[2] = initialSistLagretTidspunkt;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    form,
    veiviserSteg,
    focusThisOnValidationErrorsRef,
    isSavingUtkast,
    utkastSistLagretTidspunkt,
    isPendingProceedToOppsummering,
    isPendingExitAndContinueLater,
    isPendingFerdigstillPlan,
    saveIfChangesAndExit,
    goBackToFyllUtPlanSteg,
    lagreUtkastError,
    ferdigstillPlanError
  } = useOppfolgingsplanForm(t1);
  let t2;
  if ($[4] !== form) {
    t2 = function handleFortsettTilOppsummering() {
      logAnalyticsEvent(fyllUtPlanSkjemaStegFullfortEvent);
      form.handleSubmit({
        submitAction: "fortsettTilOppsummering"
      });
    };
    $[4] = form;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleFortsettTilOppsummering = t2;
  let t3;
  if ($[6] !== form) {
    t3 = function handleFerdigstillPlan() {
      logAnalyticsEvent(fyllUtPlanSkjemaFullfortEvent);
      form.handleSubmit({
        submitAction: "ferdigstill"
      });
    };
    $[6] = form;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleFerdigstillPlan = t3;
  const t4 = veiviserSteg === VeiviserSteg.FYLL_UT_PLAN ? "visible" : "hidden";
  let t5;
  if ($[8] !== saveIfChangesAndExit) {
    t5 = () => {
      saveIfChangesAndExit();
    };
    $[8] = saveIfChangesAndExit;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = !userHasEditAccess;
  let t7;
  if ($[10] !== erITiltaksgruppe || $[11] !== focusThisOnValidationErrorsRef || $[12] !== form || $[13] !== handleFortsettTilOppsummering || $[14] !== isPendingExitAndContinueLater || $[15] !== isPendingProceedToOppsummering || $[16] !== isSavingUtkast || $[17] !== lagreUtkastError || $[18] !== t5 || $[19] !== t6 || $[20] !== utkastSistLagretTidspunkt) {
    t7 = <FyllUtPlanSteg form={form} isSavingUtkast={isSavingUtkast} isPendingProceedToOppsummering={isPendingProceedToOppsummering} isPendingExitAndContinueLater={isPendingExitAndContinueLater} utkastSistLagretTidspunkt={utkastSistLagretTidspunkt} errorSummaryRef={focusThisOnValidationErrorsRef} onAvsluttOgFortsettSenereClick={t5} onGoToOppsummeringClick={handleFortsettTilOppsummering} isFormReadOnly={t6} lagreUtkastError={lagreUtkastError} erITiltaksgruppe={erITiltaksgruppe} />;
    $[10] = erITiltaksgruppe;
    $[11] = focusThisOnValidationErrorsRef;
    $[12] = form;
    $[13] = handleFortsettTilOppsummering;
    $[14] = isPendingExitAndContinueLater;
    $[15] = isPendingProceedToOppsummering;
    $[16] = isSavingUtkast;
    $[17] = lagreUtkastError;
    $[18] = t5;
    $[19] = t6;
    $[20] = utkastSistLagretTidspunkt;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== t4 || $[23] !== t7) {
    t8 = <Activity mode={t4}>{t7}</Activity>;
    $[22] = t4;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  const t9 = veiviserSteg === VeiviserSteg.OPPSUMMERING ? "visible" : "hidden";
  let t10;
  if ($[25] !== erITiltaksgruppe || $[26] !== ferdigstillPlanError || $[27] !== form || $[28] !== goBackToFyllUtPlanSteg || $[29] !== handleFerdigstillPlan || $[30] !== isPendingFerdigstillPlan) {
    t10 = <OppsummeringSteg form={form} isPendingFerdigstillPlan={isPendingFerdigstillPlan} onGoBack={goBackToFyllUtPlanSteg} onFerdigstillPlanClick={handleFerdigstillPlan} ferdigstillPlanError={ferdigstillPlanError} erITiltaksgruppe={erITiltaksgruppe} />;
    $[25] = erITiltaksgruppe;
    $[26] = ferdigstillPlanError;
    $[27] = form;
    $[28] = goBackToFyllUtPlanSteg;
    $[29] = handleFerdigstillPlan;
    $[30] = isPendingFerdigstillPlan;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== t10 || $[33] !== t9) {
    t11 = <Activity mode={t9}>{t10}</Activity>;
    $[32] = t10;
    $[33] = t9;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  let t12;
  if ($[35] !== t11 || $[36] !== t8) {
    t12 = <section>{t8}{t11}</section>;
    $[35] = t11;
    $[36] = t8;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  return t12;
}